import { render } from "./CrudVisitTypes.vue?vue&type=template&id=7808d52c&scoped=true"
import script from "./CrudVisitTypes.vue?vue&type=script&lang=js"
export * from "./CrudVisitTypes.vue?vue&type=script&lang=js"

import "./CrudVisitTypes.vue?vue&type=style&index=0&id=7808d52c&lang=css"
import "./CrudVisitTypes.vue?vue&type=style&index=1&id=7808d52c&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7808d52c"]])

export default __exports__